import { CopyType } from '@/const/lits';
import { ISpace } from '@/interface';
import { postMaterial } from '@/utils/material';
import { transformObjectDeep } from '@/utils/tans/object';

import { apiPathServer } from './api-config';
import { CgiResp } from './cgi';
import { API_PREFIX, request } from './request';

/**
 * 保存项目信息
 */
export const modifySpaceDetail = async (space: ISpace) => {
  const { materialMap, ...postData }: any = space;
  postData.materialMap = postMaterial(postData, materialMap);
  const res = await request(`${API_PREFIX}${apiPathServer.postSpace}`, {
    method: 'POST',
    body: transformObjectDeep(postData, 'snake'),
  });
  return res;
};

/**
 * 删除项目信息
 */
export const deleteSpace = async (id: string) => {
  const res = await request(`${API_PREFIX}${apiPathServer.deleteSpace}`, {
    method: 'POST',
    body: { id },
  });
  return res;
};

/**
 * copy项目信息
 */
export const copySpace = async (id: string) => {
  const res = await request(`${API_PREFIX}${apiPathServer.copy}`, {
    method: 'POST',
    body: { copy_id: id, type: CopyType.SPACE },
  });
  return res;
};

/**
 * 拉取space详情
 */
export const fetchSpaceDetail = async (id: string, depth?: number) => {
  const res = await request<CgiResp<ISpace>>(`${API_PREFIX}${apiPathServer.spaceDetail}`, {
    query: {
      id,
      depth,
    },
  });
  return {
    ...res,
    data: transformObjectDeep(res?.data, 'camel') as ISpace,
  };
};

/**
 *  拉取列表
 * @param param0
 * @returns
 */
export const fetchSpaceList = async ({
  page = 1,
  size = 10,
}: {
  page?: number;
  size?: number;
}): Promise<{
  list: ISpace[];
  pageInfo: {
    total: number;
    current: number;
    pageSize: number;
  }
}> => {
  const res = await request(`${API_PREFIX}${apiPathServer.spaceList}`, {
    query: {
      page,
      size,
    },
  });
  const { list, pageinfo: pageInfo } = res?.data || { list: [] };
  return {
    list: list?.map((item: any) => transformObjectDeep(item, 'camel')) || [],
    pageInfo: {
      total: pageInfo?.total || 0,
      current: pageInfo?.page || 1,
      pageSize: pageInfo?.size || 10,
    },
  };
};

